import EditDetailFormContainer from './edit-policies-and-terms-container';

export default EditDetailFormContainer;
